<span class="loading" *ngIf="loading">
    <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header [screentitle]='title'></app-header>
<app-side-menu-bardashboard></app-side-menu-bardashboard>
<div class="main-content">
    <!-- <div class="heading">
        <label class="heading-text">Data Upload Status</label>
    </div> -->
    <!-- <div class="note">
      <span class="note-content">H1 updates will be displayed on this screen in Jul, Aug & Sep</span><br>
      <span class="note-content">H2 updates will be displayed on this screen in Jan, Feb & Mar</span><br>
    </div> -->
    <div *ngIf="showData">
      <mat-tab-group animationDuration="0ms" (selectedTabChange) = "onTabClick($event)">
        <mat-tab label="Incident Data Upload - Status">
          <div class="filters">
            
          </div>
          <div class="incident-container mat-elevation-z8">
            <table mat-table [dataSource]="incidentDataUploadStatusDataSource">
              <!-- Cluster Column -->
              <ng-container matColumnDef="subregion">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> BU/GBU Sub Region </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element">
                  <span>{{element.subregion}}</span>
                </td>
              </ng-container>
              <!-- Total No of Sites Column -->
              <ng-container matColumnDef="Total No of Sites">
                <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Total No of Sites </th>
                <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.noofsites}} </td>
              </ng-container>
              <!-- No of Site Uploaded Data Column -->
              <ng-container matColumnDef="No of Site Uploaded Data">
                <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> No of Site Uploaded Data </th>
                <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.noofsitesuploadeddata}} </td>
              </ng-container>
              <!-- Data Upload Percentage Column -->
              <ng-container matColumnDef="Data Upload Percentage">
                <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Data Upload % </th>
                <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.datauploadpercentage}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="datauploadStatusCols;sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: datauploadStatusCols;"></tr>
            </table>
          </div> 
          <div class="incident-container mat-elevation-z8">
            <table mat-table [dataSource]="overallDataUploadStatusDataSource">
              <!-- Cluster Column -->
              <ng-container matColumnDef="subregion">
                <td class="leftHeaderCell" style="width: 336px;" mat-cell *matCellDef="let element">
                  <span>{{element.subregion}}</span>
                </td>
              </ng-container>
              <!-- Total No of Sites Column -->
              <ng-container matColumnDef="Total No of Sites">
                <td class="centerHeaderCell" mat-cell *matCellDef="let element"> {{element.noofsites}} </td>
              </ng-container>
              <!-- No of Site Uploaded Data Column -->
              <ng-container matColumnDef="No of Site Uploaded Data">
                <td class="rightHeaderCell" mat-cell *matCellDef="let element"> {{element.noofsitesuploadeddata}} </td>
              </ng-container>
              <!-- Data Upload Percentage Column -->
              <ng-container matColumnDef="Data Upload Percentage">
                <td class="rightHeaderCell" mat-cell *matCellDef="let element"> {{element.datauploadpercentage}} </td>
              </ng-container>
              <tr mat-row *matRowDef="let row; columns: datauploadStatusCols;"></tr>
            </table>
          </div>   
        </mat-tab>
        <mat-tab label="Incident Data Upload - Detail View">
          <div class="filters" [formGroup]="incidentUploadForm">
            <!-- Cluster -->
            <div class="filtersDropdown">
              <mat-form-field appearance="fill" class="datepickerwidth">
                <mat-label>Select BU/Sub Region</mat-label>
                <mat-select [(ngModel)]="clusterdefault" formControlName="clusters" (selectionChange)="updateClusterData()">
                  <mat-option *ngFor="let clus of cluster" [disabled]="disableCluster" [value]="clus">{{clus}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="incident-container2 mat-elevation-z8">
            <mat-paginator #paginator 
                [pageSize]="5"
                [pageSizeOptions]="[5, 10, 20,30]"
                showFirstLastButtons>
            </mat-paginator>
            <table mat-table [dataSource]="dataSource">
              <!-- Cluster Column -->
              <ng-container matColumnDef="subregion">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> BU/GBU Sub Region </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element">
                  <span>{{element.subregion}}</span>
                </td>
              </ng-container>
              <!-- Site Column -->
              <ng-container matColumnDef="Site">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Site </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.site}} </td>
              </ng-container>
              <!-- Big Category Column -->
              <ng-container matColumnDef="Business Group">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Business Group </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.businessgroup}} </td>
              </ng-container>
              <!-- Last Updated Date Column -->
              <ng-container matColumnDef="Last Updated Date">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Last Upload Date </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.lastupdateddate | date: 'dd/MM/yyyy HH:mm:ss'}} </td>
              </ng-container>
              <!-- Last Updated By Column -->
              <ng-container matColumnDef="Last Updated User">
                <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Last Updated User </th>
                <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.lastupdateduser}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="datauploadClusterCols;sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: datauploadClusterCols;"></tr>
            </table>
          </div>  
        </mat-tab>
      </mat-tab-group>
    </div>
</div>